(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cto-insurance-scripts"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() {
    const url = window.location.href;
    $(document).on('click', '#apple-care-add', function (event) {
      var isChecked = $('#add-apple-care').is(':checked');
      if (isChecked) {
        $('#add-apple-care').prop('checked', false);
        $('#apple-care-add').children('label').removeClass('checked');
      } else {
        $('#add-apple-care').prop('checked', true);
        $('#apple-care-add').children('label').addClass('checked');
        $('#remove-insurance').prop('checked', false);
        $('#insurance-remove').children('label').removeClass('checked');
      }
      var appleCareID = $(this).attr("data-index");
      $("#apple-care-varid").val(appleCareID);
      updatePriceAfterAddingCareOrWarranty();
    });

    $(document).on('click', '#secWarranty-add', function (event) {
      var isChecked2 = $('#add-secWarranty').is(':checked');
      if (isChecked2) {
        $('#add-secWarranty').prop('checked', false);
        $('#secWarranty-add').children('label').removeClass('checked');
      } else {
        $('#add-secWarranty').prop('checked', true);
        $('#secWarranty-add').children('label').addClass('checked');
        $('#remove-insurance').prop('checked', false);
        $('#insurance-remove').children('label').removeClass('checked');
      }
      var secWarrantyID = $(this).attr("data-index");
      $("#secWarranty-varid").val(secWarrantyID);
      updatePriceAfterAddingCareOrWarranty();
    });

    $(document).on('click', '#insurance-remove', function (event) {
      var isChecked1 = $('#add-apple-care').is(':checked');
      var isChecked2 = $('#add-secWarranty').is(':checked');
      var isChecked3 = $('#remove-insurance').is(':checked');

      $('#remove-insurance').prop('checked', true);
      $('#insurance-remove').children('label').addClass('checked');

      // Add/remove checked class to 'AppleCare+' and 'Second Warrany' checkboxes
      if (isChecked1 || isChecked2) {
        $('#add-apple-care').prop('checked', false);
        $('#add-secWarranty').prop('checked', false);
        $('#apple-care-add').children('label').removeClass('checked');
        $('#secWarranty-add').children('label').removeClass('checked');
      }

      $("#secWarranty-varid").val('');
      $("#apple-care-varid").val('');
      updatePriceAfterAddingCareOrWarranty();
    });

    function updateCTOHeader(el, price) {
      if (!el && !price) return;

      const $dynamicPrice = $('.js-cto-from-pricing');
      const $dynamicNoFromPrice = $('.js-cto-dynamic-pricing');
      const $dynamicMonthlyPrice = document.querySelectorAll('.js-cto-dynamic-pricing-monthly');
      const $mobileCartTotal = $('.js-sticky-atc-mobile .js-net-monthly-pricing-pdp-trigger span');
      const $headerMonthly = $('.js-cto-header-sticky .cto-header__nmp > div:not(.is-hidden) .js-product-price-with-care-warranty').first();

      if ($dynamicPrice && $dynamicPrice.length) {
        const hasParentWithClass = $(el).closest('.js-cto-summary-price')?.length > 0;
        if (hasParentWithClass) {
          const productPriceText = SDG.Data.productPriceFrom.replace(`\{\{ price \}\}`, price);

          $($dynamicPrice).each((i, $price) => {
            $($price).html(productPriceText);
          });

          $($dynamicNoFromPrice).each((i, $price) => {
            $($price).html(price);
          });
        }

        if ($dynamicMonthlyPrice?.length > 0) {
          const monthlyParent = $(el).closest('.net-monthly-pricing')?.length > 0;

          [...$dynamicMonthlyPrice].forEach($price => {
            const val = $price.querySelector('.js-product-price-with-care-warranty');

            if (monthlyParent && val) {
              val.innerHTML = price;
            }
          });

          if ($mobileCartTotal && $headerMonthly) {
            const $headerMonthlyPrice = $($headerMonthly).html();
            const $headerMonthlyNMPMonths = $($headerMonthly).data('price-calculation');
            const $nmpPriceCalculationText = SDG.Data.nmpPriceCalculation.replace(`\{\{ per_month \}\}`, $headerMonthlyNMPMonths);
            const $nmpPriceCalculation = `${$headerMonthlyPrice} ${$nmpPriceCalculationText}`;
            $($mobileCartTotal).html($nmpPriceCalculation);
          }
        }
      }
    }

    function updatePriceAfterAddingCareOrWarranty() {
      const isAppleCareAdded = $('#add-apple-care').is(':checked');
      const isWarrantyAdded = $('#add-secWarranty').is(':checked');
      const hasTradeIn = $('#selected-trade-in-value').val() && $('#selected-trade-in-value').val() !== '0' && $("#selected-trade-in-device").val() !== '';
      const hiddenSelectedTradeInValue = $('#selected-trade-in-value').val();
      const tradeInPrice = hiddenSelectedTradeInValue
        ? formatMoney(hiddenSelectedTradeInValue)
        : 0;

      $('.two-price .js-product-price-with-care-warranty, .cto-summary__price-wrapper .js-product-price-with-care-warranty, .js-sticky-atc-mobile .js-product-price-with-care-warranty').each(function(i, $productPrice) {
        let price = $(this).attr('data-price');
        const nmpPriceCalculation = $(this).data('priceCalculation');

        if (isAppleCareAdded && isWarrantyAdded && hasTradeIn) {
          price = setPriceWithTradeIn('data-price-with-care-and-secWarranty', $productPrice);
        } else if (isAppleCareAdded && isWarrantyAdded) {
          price = $(this).attr('data-price-with-care-and-secWarranty');
        } else if (isAppleCareAdded && hasTradeIn) {
          price = setPriceWithTradeIn('data-price-with-care', $productPrice);
        } else if (isWarrantyAdded && hasTradeIn) {
          price = setPriceWithTradeIn('data-price-with-secWarranty', $productPrice);
        } else if (isAppleCareAdded) {
          price = $(this).attr('data-price-with-care');
        } else if (isWarrantyAdded) {
          price = $(this).attr('data-price-with-secWarranty');
        } else if (hasTradeIn) {
          price = setPriceWithTradeIn('data-price', $productPrice);
        }

        $(this).html(price);

        // update cto header price
        updateCTOHeader(this, price);

      });
      if (isAppleCareAdded || isWarrantyAdded) {
        $('.js-cto-insurance-selected-option').html(`${isAppleCareAdded && isWarrantyAdded ? 'iDigitalCare+</br> iDigitalCare' : isAppleCareAdded ? 'iDigitalCare+' : 'iDigitalCare'}`);
        $('.js-cto-summary-protection-value').html(`${isAppleCareAdded && isWarrantyAdded ? 'iDigitalCare+ & iDigitalCare' : isAppleCareAdded ? 'iDigitalCare+' : 'iDigitalCare'}`);
        $('.js-cto-summary-protection').removeClass('hidden');
      }

      if (!isAppleCareAdded && !isWarrantyAdded) {
        $('.js-cto-insurance-selected-option').html(`${SDG.Data.ctoNoCoverage}`);
        $('.js-cto-summary-protection-value').html(`${SDG.Data.ctoNoCoverage}`);
        $('.js-cto-summary-protection').removeClass('hidden');
      }
    }

    if (url.includes('products')) {
      const insuranceInput = $('#remove-insurance');
      insuranceInput.click();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cto-update-message-scripts"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
    SDG.updateMessage = function () {
      const config = {
        dom: {
          modal: 'ctoUpdateMessage',
          modal_close_button: 'ctoUpdateMessageClose',
          modal_cto: 'cto-update-message',
          modal_open_button: '.js-combination-modal-open_button',
          modal_copy: '.js-update-message-content',
        },
        cls: {
          error: 'modal__input--error',
          hidden: 'hide',
        },
      };

      const $modal = document.getElementById(config.dom.modal);
      const $closeButton = document.getElementById(config.dom.modal_close_button);
      const $isCto = $modal?.classList.contains(config.dom.modal_cto);
      const $updateMessage = $modal?.querySelector(config.dom.modal_copy) || null;

      function init() {
        if ($modal && $closeButton) {
          addEvents();
        }

        window.refreshUpdateMessage = resetModalState;
        window.initUpdateMessage = init;
      }

      /**
       * Add events
       * @description Adds events
       * @return {void}
       */
      function addEvents() {
        if ($closeButton) {
          $closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            closeModal(e);
          });
        }
      }

      /**
       * Open Modal
       * @description Opens modal
       * @param {Event} e - Event
       * @return {void}
       */
      function openModal($message) {
        clearTimeout(window.closeUpdateMessageTimeout);
        if ($isCto && $message) {
          setCTOUpdateMessage($message);
        }

        $modal.style.opacity = 1;
        $modal.style.visibility = 'visible';
        $modal.setAttribute('aria-hidden', false);

        // small timeout to allow modal to open before trapping focus
        setTimeout(() => {
          trapFocus($modal);
        }, 550);

        window.closeUpdateMessageTimeout = setTimeout(() => {
          const $closeUpdateMessageButton = document.getElementById('ctoUpdateMessageClose');
          if (window.updateMessage && $closeUpdateMessageButton) {
            $closeUpdateMessageButton.click();
          }
        }, 5000);
      }

      /**
        * Close Modal
        * @description Closes modal
        * @return {void}
        */
      function closeModal() {
        $modal.style.opacity = 0;
        $modal.setAttribute('aria-hidden', true);

        setTimeout(() => {
          resetVisibilityState();
        }, 1000);
      }

      /**
        * Reset Visibility State
        * @description Resets visiblity state
        * @return {void}
        */
      function resetVisibilityState() {
        $modal.style.visibility = 'hidden';
      }

      /**
        * Reset Modal State
        * @description Resets modal state
        * @return {void}
        */
      function resetModalState() {
        clearModalContent();
      }

      /**
        * Clear Modal Content
        * @description Clears modal content
        * @return {void}
        */
      function clearModalContent() {
        $updateMessage.innerHTML = '';
        window.updateMessage = '';
      }

      /**
        * Trap Focus
        * @description Traps focus within modal
        * @param {HTMLElement} element - Element to trap focus within
        * @return {void}
        */
      function trapFocus(element) {
        const focusableEls = element.querySelectorAll(
          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
        );
        if (!focusableEls?.length > 0) return;

        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];

        if (!firstFocusableEl || !lastFocusableEl) return;

        $closeButton.focus();
        element.addEventListener('keydown', (e) => {
          const isTabPressed = e.key === 'Tab';
          const isEscape = e.key === 'Escape';
          const isEnter = e.key === 'Enter';

          if (isEnter) {
            e.preventDefault();
            $closeButton.click();
          }

          if (isEscape) {
            closeModal();
          }

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus();
              e.preventDefault();
            }
          } /* tab */ else {
            if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus();
              e.preventDefault();
            }
          }
        });
      }

      /**
        * Set CTO Update Message
        * @description Sets the CTO update message
        * @return {void}
        */
      function setCTOUpdateMessage() {
        $updateMessage.innerHTML = window.updateMessage;
      }

      /**
        * return
        * @type {Object}
        */
      return {
        init,
        openModal,
      };
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-js-account"] && !Shopify.designMode) return;
  try {
    class WDAccountPage extends HTMLElement {
        static selectors = {
            tablistSelector: '.wd-account-tablist',
            tabsSelector: '.wd-account-tab',
            contentSelector: '.wd-account-content-section',
            contentTitleSelector: '.wd-account-content-title',
            logoutSelector: '.wd-account-logout'
        };

        static focusableSelector =
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

        constructor() {
            super();
            this.init();
        }

        init() {
            this.tablist = this.querySelector(WDAccountPage.selectors.tablistSelector);
            this.tabs = () => Array.from(this.querySelectorAll(WDAccountPage.selectors.tabsSelector));
            this.setupEventListeners();
            this.openDefaultUrlTab();
            this.handlePostLogin();
            this.announceActiveTabOnLoad();
        }

        setupEventListeners() {
            const tabs = this.querySelectorAll(WDAccountPage.selectors.tabsSelector);
            const logout = this.querySelectorAll(WDAccountPage.selectors.logoutSelector);

            tabs.forEach((tab) => {
                tab.addEventListener('click', (event) => this.handleTabClick(event));
                tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
            });

            if (this.tablist) {
                this.tablist.addEventListener('focusin', (event) => {
                    const t = event.target;
                    if (t.matches && t.matches(WDAccountPage.selectors.tabsSelector)) {
                        this.activateTab(t, { fromFocus: true });
                    }
                });
            }

            logout.forEach((el) => {
                el.addEventListener('click', (event) => this.handleLogoutClick(event));
            });

            this.addEventListener('click', (event) => {
                const switchBtn = event.target.closest('[data-switch-tab]');
                if (!switchBtn || !this.contains(switchBtn)) return;
                const tabName = switchBtn.getAttribute('data-switch-tab');
                const tab = this.querySelector(`[data-tab="${tabName}"]`);
                if (tab) this.activateTab(tab);
            });
        }

        openDefaultUrlTab() {
            const url = new URL(window.location.href);
            const tabParam = url.searchParams.get('tab');
            const validTabOptions = ['profile', 'order-history', 'club', 'students'];
            let target = null;
            if (tabParam && validTabOptions.includes(tabParam)) {
                target = this.querySelector(`[data-tab="${tabParam}"]`);
            }
            if (!target) {
                target = this.querySelector('[data-tab="profile"]');
            }
            if (target) {
                this.activateTab(target, { focus: false });
            }
        }

        getActiveTabLabel() {
            const activeTab = this.querySelector('[role="tab"][aria-selected="true"]');
            return activeTab ? activeTab.textContent.trim() : 'פרופיל';
        }

        updateDocumentTitle(tabLabel) {
            const sep = ' – ';
            const parts = document.title.split(sep);
            const shop = parts.length > 1 ? parts[parts.length - 1] : 'iDigital';
            document.title = `${tabLabel}${sep}${shop}`;
        }

        announceTab(message) {
            const announce = document.getElementById('wd-account-post-login-announce');
            if (!announce) return;
            announce.textContent = '';
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    announce.textContent = message;
                });
            });
        }

        /** After login redirect: announce once on the final stable account view */
        handlePostLogin() {
            if (sessionStorage.getItem('wd_post_login') !== '1') return;

            this._postLoginPending = true;
            let differed = false;
            const announceWhenStable = () => {
                if (!differed) {
                    return setTimeout(() => {
                        differed = true;
                        announceWhenStable();
                    }, 2000);
                }
                if (sessionStorage.getItem('wd_post_login') !== '1') return;
                sessionStorage.removeItem('wd_post_login');
                this._postLoginPending = false;

                const main = document.getElementById('MainContent');
                const tabLabel = this.getActiveTabLabel();
                this.updateDocumentTitle(tabLabel);
                this.announceTab(`התחברת בהצלחה. אזור החשבון שלך, לשונית ${tabLabel}.`);

                requestAnimationFrame(() => {
                    if (main) main.focus({ preventScroll: true });
                });
            };

            if (document.readyState === 'complete') {
                announceWhenStable();
            } else {
                window.addEventListener('load', announceWhenStable, { once: true });
            }
        }

        /** On normal account page open, announce the active tab first (e.g. "פרופיל"). */
        announceActiveTabOnLoad() {
            if (this._postLoginPending) return;
            const tabLabel = this.getActiveTabLabel();
            this.updateDocumentTitle(tabLabel);
            this.announceTab(tabLabel);
        }

        handleLogoutClick() {
            window.location.href = '/account/logout';
        }

        handleTabClick(event) {
            event.currentTarget.focus();
        }

        handleTabKeydown(event) {
            const tab = event.currentTarget;
            const list = this.tabs();
            const idx = list.indexOf(tab);
            if (idx < 0) return;

            const isRtl = this.tablist && getComputedStyle(this.tablist).direction === 'rtl';

            switch (event.key) {
                case 'ArrowRight':
                    event.preventDefault();
                    this.focusTabAtIndex(idx + (isRtl ? -1 : 1));
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    this.focusTabAtIndex(idx + (isRtl ? 1 : -1));
                    break;
                case 'Home':
                    event.preventDefault();
                    this.focusTabAtIndex(0);
                    break;
                case 'End':
                    event.preventDefault();
                    this.focusTabAtIndex(list.length - 1);
                    break;
                case 'Enter':
                case ' ':
                    event.preventDefault();
                    this.moveFocusIntoPanel(tab.getAttribute('data-tab'));
                    break;
                default:
                    break;
            }
        }

        focusTabAtIndex(index) {
            const list = this.tabs();
            if (!list.length) return;
            const len = list.length;
            const nextIndex = ((index % len) + len) % len;
            list[nextIndex].focus();
        }

        activateTab(tab, options = {}) {
            if (!tab) return;
            const { focus = true, fromFocus = false } = options;
            const targetTab = tab.getAttribute('data-tab');
            const allTabs = this.querySelectorAll(WDAccountPage.selectors.tabsSelector);
            const allContents = this.querySelectorAll(WDAccountPage.selectors.contentSelector);

            allTabs.forEach((t) => {
                const isActive = t.getAttribute('data-tab') === targetTab;
                t.classList.toggle('active', isActive);
                t.setAttribute('aria-selected', isActive ? 'true' : 'false');
                t.tabIndex = isActive ? 0 : -1;
            });

            allContents.forEach((content) => {
                const isActive = content.id === `${targetTab}-content`;
                if (isActive) {
                    content.removeAttribute('hidden');
                } else {
                    content.setAttribute('hidden', '');
                }
            });

            const tabLabel = tab.textContent.trim();
            const contentTitle = this.querySelector(WDAccountPage.selectors.contentTitleSelector);
            if (contentTitle) {
                contentTitle.textContent = tabLabel;
                contentTitle.setAttribute('aria-label', tabLabel);
            }

            this.updateDocumentTitle(tabLabel);

            window.history.replaceState(null, '', `?tab=${targetTab}`);

            if (focus && !fromFocus) {
                tab.focus();
            }
        }

        moveFocusIntoPanel(dataTab) {
            const panel = this.querySelector(`#${dataTab}-content`);
            if (!panel || panel.hasAttribute('hidden')) return;

            const first = this.getFirstVisibleFocusable(panel);
            if (first) first.focus();
        }

        getFirstVisibleFocusable(container) {
            for (const el of container.querySelectorAll(WDAccountPage.focusableSelector)) {
                if (el.offsetParent !== null || el.getClientRects().length > 0) {
                    return el;
                }
            }
            return null;
        }
    }
    
    if (!customElements.get('wd-account-page')) {
        customElements.define('wd-account-page', WDAccountPage);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-js-careers"] && !Shopify.designMode) return;
  try {
    const API_URL = `${window.location.origin}/apps/api/`; // TODO: change to /api/ for production
  
  class WDCareersPage extends HTMLElement {
    /** @type {Array<{ "id": Number, "title": string, "description": string, "branch": string, "area": string, "type": string, "client_name": string}>} */
    jobs = [];
    /** @type {Array<{ "filed": string, "value": string }>} */
    filters = [];
    /** @type {string} */
    searchTerm = '';
    loadMoreJobsCount = 8;
    /** @type {number} */
    visibleJobsCount = 0;

    static selectors = {
      filterSelector: '.wd-career-filter:not(.wd-career-filter_options)',
      careersListSelector: '.wd-all-careers-list',
      moreJobsButtonSelector: '.wd-all-careers_more_jobs',
      jobsCountSelector: '.careers_count',
      searchInputSelector: '.wd-all-careers_search',
    };

    constructor() {
      super();
      this.jobs = [];
      this.filters = [];
      this.init();
    }

    init() {
      this.setupEventListeners();
      this.showInitialJobs().then(this.setupFilters.bind(this));
    }

    setupEventListeners() {
      const filters = this.querySelectorAll(WDCareersPage.selectors.filterSelector);
      const showMoreButton = this.querySelector(WDCareersPage.selectors.moreJobsButtonSelector);
      const searchInput = this.querySelector(WDCareersPage.selectors.searchInputSelector);
      filters.forEach((filter) => {
        filter.addEventListener('click', (event) => this.handleFilterClick(event));
        filter.addEventListener('focusin', () => this.openFilter(filter));
        filter.addEventListener('focusout', (event) => this.handleFilterFocusOut(event, filter));
      });
      this.ownerDocument.addEventListener('click', (event) => this.handleDocumentClick(event));
      showMoreButton.addEventListener('click', () => this.showEightMoreJobs());
      if (searchInput) searchInput.addEventListener('input', (event) => this.handleSearchInput(event));
    }

    setupFilters() {
      const filters = this.querySelectorAll(WDCareersPage.selectors.filterSelector);
      filters.forEach((filter) => {
        const filterKey = filter.dataset.filterKey;
        this.filters.push({ field: filterKey, value: '' });
        const set = new Set();
        this.jobs.forEach((job) => job[filterKey] && set.add(job[filterKey]));
        const values = Array.from(set).sort();
        values.forEach((value) => {
          const option = this.ownerDocument.createElement('p');
          option.className = 'wd-career-filter_option';
          option.dataset.filterValue = value;
          option.textContent = value;
          filter.querySelector('.wd-career-filter_options').appendChild(option);
        });
      });
    }

    async showInitialJobs() {
      const moreCareersButton = this.querySelector(WDCareersPage.selectors.moreJobsButtonSelector);
      moreCareersButton.textContent = 'טוען...';
      this.jobs = await fetchJobs();
      this.visibleJobsCount = this.loadMoreJobsCount;
      this.renderFilteredJobs();
    }
    async showEightMoreJobs() {
      this.visibleJobsCount += this.loadMoreJobsCount;
      this.renderFilteredJobs();
    }

    handleFilterClick(event) {
      const clickedFilter = event.currentTarget;
      const target = event.target;
      const isOption = target.classList.contains('wd-career-filter_option');
      const isMainLabel = target.classList.contains('selected-value');

      if (!clickedFilter.classList.contains('active')) this.openFilter(clickedFilter);

      // main label clicked - open menu & exit
      if (isMainLabel) return;

      // expected target - exit
      if (!isOption) return;

      const parent = target.closest(WDCareersPage.selectors.filterSelector);

      parent.querySelector('.wd-career-filter_option.selected')?.classList.remove('selected');
      target.classList.add('selected');

      const selectedValue = target.dataset.filterValue;
      const filterKey = parent?.dataset?.filterKey;

      // update filter value
      const targetFilter = this.filters.find((filter) => filter.field == filterKey);
      if (targetFilter) targetFilter.value = selectedValue;

      //update main label
      parent.querySelector('.wd-career-filter_activeOption .selected-value').textContent = target.textContent;

      // preform filter jobs
      this.filterJobs();
      clickedFilter.classList.remove('active');
    }

    /** on click outside of filters, close them */
    handleDocumentClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (!target.closest(WDCareersPage.selectors.filterSelector)) this.closeAllFilters();
    }

    /** on focus out of filter, close it */
    handleFilterFocusOut(event, filter) {
      const relatedTarget = event.relatedTarget;
      if (!(relatedTarget instanceof Element) || !filter.contains(relatedTarget)) filter.classList.remove('active');
    }

    /** open filter & close others */
    openFilter(filter) {
      this.closeAllFilters(filter);
      filter.classList.add('active');
    }

    /** close all filters (ui) */
    closeAllFilters(except) {
      const filters = this.querySelectorAll(WDCareersPage.selectors.filterSelector);
      filters.forEach((filter) => {
        if (filter !== except) filter.classList.remove('active');
      });
    }

    /** change visible jobs based on filters */
    filterJobs() {
      // reset to first page on any filter change
      this.visibleJobsCount = this.loadMoreJobsCount;
      this.renderFilteredJobs();
    }

    /** @param {InputEvent} event */
    handleSearchInput(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;

      this.searchTerm = target.value || '';
      // reset to first page on search change
      this.visibleJobsCount = this.loadMoreJobsCount;
      this.renderFilteredJobs();
    }

    /** get filtered jobs based on selected filters */
    getFilteredJobs() {
      return this.jobs.filter((job) =>
        this.filters.every((filter) => !filter.value || filter.value == job[filter.field])
      );
    }

    /**
     * @param {string} searchTerm
     * @param {typeof this.jobs[number][]} filteredJobs
     * */
    searchRelevantJobs(searchTerm, filteredJobs) {
      const similarityThreshold = 0.7; // 70% similarity
      const normalizedSearchTerm = searchTerm.trim().toLowerCase();
      if (!normalizedSearchTerm) return filteredJobs;

      const searchMatched = filteredJobs.filter(j => {
        const titleWords = j.title
          .replace(/[^\w\s]|(\n+)/g, '') // remove non-alphanumeric characters and newlines
          .split(' ')
          .filter((_) => !!_) // remove empty words
        const descriptionWords = j.description
          .replace(/[^\w\s]|(\n+)/g, '') // remove non-alphanumeric characters and newlines
          .split(' ')
          .filter((_) => !!_) // remove empty words

        const match =
          // direct match search
          j.title.includes(normalizedSearchTerm) ||
          j.description?.includes(normalizedSearchTerm) ||
          // similarity match - if there is a word that is {similarityThreshold}% similar to the search term
          titleWords.some((word) => string_similarity(word, normalizedSearchTerm) > similarityThreshold) ||
          descriptionWords.some((word) => string_similarity(word, normalizedSearchTerm) > similarityThreshold);

        return match;
      });
      return searchMatched;
    }

    /** render list based on filters + visible count */
    renderFilteredJobs() {
      let filteredJobs = this.getFilteredJobs();
      if (this.searchTerm.trim()) filteredJobs = this.searchRelevantJobs(this.searchTerm, filteredJobs);
      const list = this.querySelector(WDCareersPage.selectors.careersListSelector);
      list.innerHTML = '';
      filteredJobs.slice(0, this.visibleJobsCount).forEach(this.render.bind(this));

      const jobsCountEl = this.querySelector(WDCareersPage.selectors.jobsCountSelector);
      jobsCountEl.textContent = String(filteredJobs.length);

      const moreCareersButton = this.querySelector(WDCareersPage.selectors.moreJobsButtonSelector);
      if (filteredJobs.length === 0) {
        moreCareersButton.style.display = 'flex';
        moreCareersButton.textContent = 'לא נמצאו משרות';
        moreCareersButton.disabled = true;
        return;
      }

      const canShowMore = filteredJobs.length > this.visibleJobsCount;
      if (canShowMore) {
        moreCareersButton.textContent = 'משרות נוספות';
        moreCareersButton.style.display = 'flex';
        moreCareersButton.disabled = false;
      } else {
        moreCareersButton.style.display = 'none';
      }
    }

    /** @param {typeof this.jobs[number]} data */
    render(data) {
      const wrapper = this.ownerDocument.createElement('div');
      wrapper.className = 'wd-career-item';
      wrapper.dataset.jobId = data.id;

      const title = this.ownerDocument.createElement('h3');
      title.className = 'wd-career-item_title';
      title.textContent = data.title.slice(0, 100) + (data.title.length > 100 ? '...' : '');

      const desc = this.ownerDocument.createElement('p');
      desc.className = 'wd-career-item_description';
      desc.innerHTML = data.description.replace(/\n+/g, '<br>');

      const descSeparator = this.ownerDocument.createElement('div');
      descSeparator.className = 'wd-career-item_desc_separator_line';

      const branchesWrapper = this.ownerDocument.createElement('div');
      branchesWrapper.className = 'wd-career-item_branches';

      const branchesLabel = this.ownerDocument.createElement('p');
      branchesLabel.textContent = 'סניף:';
      branchesWrapper.appendChild(branchesLabel);

      const branchEl = this.ownerDocument.createElement('div');
      branchEl.className = 'wd-career-item_branch';
      branchEl.textContent = data.branch;
      branchesWrapper.appendChild(branchEl);

      const branchesFlexSpacer= this.ownerDocument.createElement('div');
      branchesFlexSpacer.style.flex = '1';
      branchesFlexSpacer.style.display = 'block';

      const link = this.ownerDocument.createElement('a');
      link.className = 'wd-career-item_link';
      link.href = `${window.location.origin}/pages/job?jobCode=${data.id}`;
      link.textContent = 'לפרטי המשרה';
      link.onclick = (event) => {
        // save job for faster loading of job page
        sessionStorage.setItem('job', JSON.stringify(data));
      }

      wrapper.append(title, desc, branchesFlexSpacer ,descSeparator, branchesWrapper, link);
      this.querySelector(WDCareersPage.selectors.careersListSelector).appendChild(wrapper);
    }
  }
  async function fetchJobs() {
    try {
      const response = await fetch(`${API_URL}career/all`);
      const data = await response.json();
      if (response.ok && data.success) {
        return data.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching jobs:', error);
      return [];
    }
  }

  window.addEventListener('load', () => {
    customElements.define('wd-careers-page', WDCareersPage);
  });

  // UTILS - calc string similarity
  function string_similarity(s1, s2) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
      return 1.0;
    }
    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
  }
  function editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0) costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1)) newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0) costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-js-tab-view"] && !Shopify.designMode) return;
  try {
    class WDTabView extends HTMLElement {
    static selectors = {
      tabButton: '.wd-tab-view__tab',
      tabPanel: '.wd-tab-view__panel',
      tabSlider: '[data-tab-slider]',
    };

    static padding = 0;

    /** Resolves a used padding/length to px (handles calc/% when Typed OM is available). */
    static usedPaddingRightPx(el) {
      el.v
      if (typeof el.computedStyleMap === 'function') {
        try {
          const v = el.computedStyleMap().get('padding-right');
          if (v && typeof v.to === 'function') {
            const px = v.to('px');
            if (px && typeof px.value === 'number') return px.value;
          }
        } catch (_) {
          /* fall through */
        }
      }
      const raw = getComputedStyle(el).paddingRight;
      const n = parseFloat(raw);
      return Number.isFinite(n) ? n : 0;
    }

    connectedCallback() {
      this.tabButtons = Array.from(this.querySelectorAll(WDTabView.selectors.tabButton));
      this.tabPanels = Array.from(this.querySelectorAll(WDTabView.selectors.tabPanel));

      if (!this.tabButtons.length || !this.tabPanels.length) return;

      // register logic for tab button click
      this.tabButtons.forEach((button) =>
        button.addEventListener('click', (e) => {
          this.setActiveTab(e.currentTarget.dataset.tab);
          requestAnimationFrame(() => {
            this.refreshActiveSlider();
          });
        })
      );

      // initialize sliders
      this.tabPanels.forEach((panel) => this.initSlider(panel));

      // set initial tab
      const initialTab = this.tabButtons.find((button) => button.classList.contains('is-active')) || this.tabButtons[0];
      this.setActiveTab(initialTab?.dataset?.tab || '1');

    }

    /** update buttons class and shows the corresponding tab view */
    setActiveTab(tabId) {
      this.tabButtons.forEach((button) => {
        const isActive = button.dataset.tab === tabId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.tabPanels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === tabId;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);

        if(isActive){
          const slider = panel.querySelector(".wd-tab-view__slider");
          slider && this.setGapToCenter(slider)
        }
      });
    }

    setGapToCenter(slider){
      const slide_count = slider.querySelectorAll(".wd-tab-view__slide").length;
      const width = Array.from(slider.querySelectorAll(".wd-tab-view__slide"))
        .reduce((acc, e) => acc + e.getBoundingClientRect().width, 0);
      const padding_right = WDTabView.padding || WDTabView.usedPaddingRightPx(slider);
      if (WDTabView.padding === 0) 
        WDTabView.padding = padding_right;
      
      const centering_gap = (document.documentElement.clientWidth - width - padding_right * 2) / (slide_count + 2);
      if(centering_gap <= 10)
        return;

      const relative_gap = centering_gap / document.documentElement.clientWidth * 100;
      const track = slider.querySelector(".slick-track")
      if(track)
        track.style.gap = relative_gap + 'vw';
    }

    refreshActiveSlider() {
      const activePanel = this.tabPanels.find((panel) => panel.classList.contains('is-active'));
      if (!activePanel || !window.jQuery) return;

      const slider = activePanel.querySelector(WDTabView.selectors.tabSlider);
      if (!slider) return;

      const $slider = window.jQuery(slider);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
      }
    }

    initSlider(panel) {
      const slider = panel.querySelector(WDTabView.selectors.tabSlider);
      if (!slider || !window.jQuery) return;

      const slide_count = slider.querySelectorAll(".wd-tab-view__slide").length;
      this.setGapToCenter(slider)

      const $slider = window.jQuery(slider);
      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      const $prevArrow = window.jQuery(panel).find('.wd-tab-view__arrow--prev');
      const $nextArrow = window.jQuery(panel).find('.wd-tab-view__arrow--next');

      $slider.on('init', function (event, slick) {
        const sliderEl = slick.$slider[0];
        setTimeout(() => {
          if (window.customSlickSlider) customSlickSlider();
          if (window.setInitialSlideVisibility) setInitialSlideVisibility(sliderEl);
        }, 300);
        $prevArrow.hide();
        $nextArrow.show();
      });

      $slider.on('afterChange', function (event, slick) {
        const sliderEl = slick.$slider[0];
        if (window.setSlideVisibility) setSlideVisibility(sliderEl);
        if (slick.currentSlide === 0) {
          $prevArrow.hide();
        } else {
          $prevArrow.show();
        }
      });

      $slider.slick({
        rtl: true,
        slidesToShow: Math.min(8,slide_count),
        slidesToScroll: 4,
        infinite: false,
        centerMode: false,
        centerPadding: '0px',
        variableWidth: true,
        dots: false,
        arrows: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        speed: 2000,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: Math.min(6,slide_count),
              slidesToScroll: 3,
              infinite: true,
              speed: 1000,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow:  Math.min(5,slide_count),
              slidesToScroll: 2,
              infinite: true,
              speed: 1000,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:  Math.min(4,slide_count),
              slidesToScroll: 3,
              infinite: true,
              speed: 500,
              variableWidth: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow:  Math.min(2,slide_count),
              slidesToScroll: 1,
              infinite: true,
              speed: 500,
              variableWidth: false,

            },
          },
        ],
      });

      if (window.adaFormatSlickSlides) {
        setTimeout(() => {
          const slickSlides = $slider.find('.slick-list .slick-slide');
          adaFormatSlickSlides(slickSlides);
        }, 250);
      }
    }

  }

  window.addEventListener('load', () => {
    if (!customElements.get('wd-tab-view')) {
      customElements.define('wd-tab-view', WDTabView);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
